import { useNavigate } from '@tanstack/react-router'
import connectionLostSvg from '@/assets/connection-lost-404.svg'

export default function NotFound() {
  const navigate = useNavigate()

  return (
    <div className="min-h-screen w-full bg-background flex items-center justify-center px-6 py-12">
      <div className="w-full max-w-xl text-center">
        <div className="mt-8 overflow-hidden rounded-2xl border bg-card">
          <img
            src={connectionLostSvg}
            alt="Connection lost illustration"
            className="block w-full h-auto"
            loading="lazy"
          />
        </div>

        <div className="mt-8">
          <button
            type="button"
            className="inline-flex items-center justify-center rounded-full bg-primary px-6 py-3 text-sm font-semibold text-primary-foreground shadow-sm hover:opacity-95 focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2"
            onClick={() => {
              navigate({ to: '/' })
            }}
          >
            Back to Home
          </button>
        </div>
      </div>
    </div>
  )
}
